var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-container"},[_c('AboveTheFold'),_c('Together'),_c('HeroSection'),_c('Container'),_c('Core'),_c('LayoutContainer'),_c('AppendixLayout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }